import React from 'react';
import './Group.scss';

const Group = ({ className = '', ...props }) => <div className={`group ${className}`} {...props} />;

export default Group;
